jQuery(document).ready(function ($) {
  var links = $('#privacy-links a');
  links.first().parent().addClass('active');

  $(window).on('scroll', function () {
    var fromTop = $(this).scrollTop() + 10; // thodo offset

    links.each(function () {
      var section = $($(this).attr('href'));

      if (section.length) {
        var sectionTop = section.offset().top;
        var sectionBottom = sectionTop + section.outerHeight();

        if (sectionTop <= fromTop && sectionBottom > fromTop) {
          links.parent().removeClass('active');
          $(this).parent().addClass('active');
        }
      }
    });
  });
});
